import { Component, OnInit } from '@angular/core';

import { AuthService } from '@auth/auth.service';

import pkg from '@package_json';

import { env } from '@environment';

@Component({
  selector: 'app-footer-version',
  templateUrl: './version.component.html',
  styleUrls: ['./version.component.scss'],
})
export class VersionComponent implements OnInit {
  version = `${pkg.version}`;
  environment = `${env}`;

  constructor(public authService: AuthService) {}

  ngOnInit(): void {}
}
